import {ITemplateCacheService} from "angular";

export const DATE_PICKER_MONTH_TEMPLATE = `
    <table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">
        <thead>
            <tr>
                <th>
                    <button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1">
                        <i aria-hidden="true" class="glyphicon glyphicon-chevron-left"></i>
                        <span class="sr-only">previous</span>
                    </button>
                </th>
                <th colspan="{{::yearHeaderColspan}}">
                    <button id="{{::uniqueId}}-title"
                        role="heading"
                        aria-live="assertive"
                        aria-atomic="true"
                        type="button"
                        class="btn btn-default btn-sm uib-title"
                        ng-click="toggleMode()"
                        ng-disabled="datepickerMode === maxMode" tabindex="-1">
                        <strong>{{title}}</strong>
                    </button>
                </th>
                <th>
                    <button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1">
                        <i aria-hidden="true" class="glyphicon glyphicon-chevron-right"></i>
                        <span class="sr-only">next</span>
                    </button>
                </th>
            </tr>
        </thead>

        <tbody>
            <tr class="uib-months" ng-repeat="row in rows track by $index" role="row">
                <td ng-repeat="dt in row" class="uib-month text-center" role="gridcell"
                    id="{{::dt.uid}}"
                    ng-class="::dt.customClass">
                    <button type="button" class="btn btn-default"
                        uib-is-class="
                        'btn-info' for selectedDt,
                        'active' for activeDt
                        on dt"
                        ng-click="select(dt.date)"
                        ng-disabled="::dt.disabled"
                        tabindex="-1">
                        <span ng-class="::{'text-info': dt.current}">
                            {{ "months." + dt.label.trim().split(' ')[0].toUpperCase() | translate }}
                        </span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
`;

/** @ngInject */
export function datePickerMonthTemplateCaching($templateCache: ITemplateCacheService) {
    $templateCache.put("uib/template/datepicker/month.html", DATE_PICKER_MONTH_TEMPLATE);
}
